import React from 'react';
import { Anchor } from '@m4b-design/components';
import styles from './index.scss';

interface AnchorToProps {
  anchor: string;
}

export const AnchorTo = ({ anchor }: AnchorToProps) => {
  return (
    <Anchor
      className={`${styles.AnchorTo} ${styles.Anchor}`}
      affix={false}
      hash={false}
      lineless={true}
      animation={false}
      boundary={159}>
      <Anchor.Link href={`#${anchor}`} title={anchor} />
    </Anchor>
  );
};
